export default __webpack_public_path__ + "static/media/opel.64829e5c.svg";